import { LinkStoryblok, StoryblokComponent } from '@/types/types-storyblok';
import { usePathname } from 'next/navigation';
import clsx from 'clsx';
import Image from 'next/image';
import { isExternalLink, resolveWebLink } from '@/storyblok/utils/link';
import Link from 'next/link';
import { StoryblokStory } from 'storyblok-generate-ts';
import { isSelectedLink } from '@/app/_components/headerSeo/utils';

type NavItemProps = {
  link: LinkStoryblok;
  isVisible: boolean;
  story: StoryblokStory<StoryblokComponent>;
  component: StoryblokComponent;
};

export const NavItem = ({ link, isVisible, story, component }: NavItemProps) => {
  const pathName = usePathname();
  const isSelected = isSelectedLink(pathName as string, link);
  const icon = link.icon;
  const hasIcon = icon && icon.filename;
  const LinkEl = link.link && isExternalLink(link.link) ? 'a' : Link;
  return (
    <li key={link._uid} role="menuitem">
      {link.link && (
        <LinkEl
          tabIndex={!isVisible || isSelected ? -1 : undefined}
          aria-current={isSelected ? 'page' : undefined}
          className={clsx(
            'flex flex-row items-center justify-start gap-2 hover:text-black focus:text-black',
            isSelected ? 'relative right-2 text-black' : 'text-[#6B7280]',
          )}
          href={resolveWebLink(link.link, { story, component })}
        >
          {!hasIcon && isSelected && <div className="h-2.5 w-2.5 rounded-full bg-elty-green" />}
          {hasIcon && (
            <Image className={clsx(!isSelected && 'opacity-70')} src={icon?.filename} alt={icon?.alt ?? ''} width={20} height={20} />
          )}
          {link.title}
        </LinkEl>
      )}
    </li>
  );
};
